import React, { useState } from 'react'

import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Typography,
	Avatar,
	Checkbox
} from '@material-ui/core'

import { getAvatarLetters } from '../../../services/helpers'
import { useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	},
	checkbox: {
		'&.Mui-disabled.Mui-checked .MuiIconButton-label .MuiSvgIcon-root': {
			fill: '#A2A1A4'
		}
	},
	avatar: {
		background: '#C4C4C4',
		height: '32px',
		width: '32px',
		marginTop: '12px',
		marginBottom: '12px'
	}
}))

const EditDogsDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [selectedPets, setSelectedPets] = useState([])

	let { isShown, setIsShown, editDogsOnVisit, isAddPet, visit, pets } = props

	const getUpdatedPets = () => {
		let petIds = []
		if (isAddPet) {
			petIds = [...visit.pet_ids, ...selectedPets]
			return petIds
		} else {
			petIds = visit.pet_ids.filter((petId) => !selectedPets.includes(petId))
			return petIds
		}
	}

	const renderPets = () => {
		let petsOnVisit = visit.pet_ids

		if (isAddPet && pets) {
			return pets.filter(p => !!p.active).map((pet) => {
				let disabled = petsOnVisit.includes(pet._id)
				let index = pets.findIndex((p) => p._id === pet._id)
				return (
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							borderBottom: `${index === pets.length - 1 ? 0 : 1}px solid #D5D5D7`
						}}
						key={pet._id}>
						<Checkbox
							checked={selectedPets.includes(pet._id) || petsOnVisit.includes(pet._id)}
							disabled={disabled}
							className={classes.checkbox}
							onChange={(e) => {
								if (selectedPets.includes(pet._id)) {
									let updatedSelectedPets = selectedPets.filter((petID) => petID !== pet._id)
									setSelectedPets(updatedSelectedPets)
								} else {
									let updatedSelectedPets = [...selectedPets, pet._id]
									setSelectedPets(updatedSelectedPets)
								}
							}}
							style={{
								marginLeft: '8px',
								marginRight: '8px'
							}}
						/>

						<Avatar
							alt={pet.name}
							src={
								pet.profile_image_file_name
									? `https://waggle-keys-prod.s3.amazonaws.com/${pet.profile_image_file_name}`
									: null
							}
							className={classes.avatar}>
							{getAvatarLetters(pet.name)}
						</Avatar>
						<Typography style={{ marginLeft: '16px', color: disabled ? '#A2A1A4' : '' }}>
							{' '}
							{pet.name}{' '}
						</Typography>
					</div>
				)
			})
		} else {
			return visit.pets.map((pet) => {
				let disabled = selectedPets.length + 1 === visit.pets.length && !selectedPets.includes(pet._id)
				let index = visit.pets.findIndex((p) => p._id === pet._id)
				return (
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							borderBottom: `${index === visit.pets.length - 1 ? 0 : 1}px solid #D5D5D7`
						}}
						key={pet._id}>
						<Checkbox
							checked={!selectedPets.includes(pet._id)}
							disabled={disabled}
							className={classes.checkbox}
							onChange={(e) => {
								if (selectedPets.includes(pet._id)) {
									let updatedSelectedPets = selectedPets.filter((petID) => petID !== pet._id)
									setSelectedPets(updatedSelectedPets)
								} else {
									let updatedSelectedPets = [...selectedPets, pet._id]
									setSelectedPets(updatedSelectedPets)
								}
							}}
							style={{
								marginLeft: '8px',
								marginRight: '8px'
							}}
						/>

						<Avatar
							alt={pet.name}
							src={
								pet.profile_image_file_name
									? `https://waggle-keys-prod.s3.amazonaws.com/${pet.profile_image_file_name}`
									: null
							}
							className={classes.avatar}>
							{getAvatarLetters(pet.name)}
						</Avatar>
						<Typography style={{ marginLeft: '16px', color: disabled ? '#A2A1A4' : '' }}>
							{' '}
							{pet.name}{' '}
						</Typography>
					</div>
				)
			})
		}
	}

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 24
				}}>
				{isAddPet ? 'ADD PETS' : 'REMOVE PETS'}
			</DialogTitle>
			<DialogContent>
				<Typography
					variant="body2"
					style={{
						marginBottom: 24
					}}>
					{isAddPet
						? 'Select which pets to add from the list of existing pet profiles on this account.'
						: 'Select which pets you’d like to remove from this appointment.'}
				</Typography>
				<div
					style={{
						border: '1px solid #D5D5D7',
						borderRadius: '6px',
						marginBottom: '16px'
					}}>
					{renderPets()}
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				{isAddPet ? (
					<Button
						variant="contained"
						disabled={!selectedPets.length}
						onClick={() => {
							editDogsOnVisit(getUpdatedPets())
							setIsShown(false)
							setTimeout(() => setSelectedPets([]), 500)
						}}
						color="secondary">
						ADD PETS
					</Button>
				) : (
					<Button
						variant="contained"
						disabled={!selectedPets.length}
						style={{ background: '#EB4C4C' }}
						onClick={() => {
							editDogsOnVisit(getUpdatedPets())
							setIsShown(false)
							setTimeout(() => setSelectedPets([]), 500)
						}}
						color="secondary">
						REMOVE PETS
					</Button>
				)}

				<Button
					variant="outlined"
					onClick={() => {
						setIsShown(false)
						setTimeout(() => setSelectedPets([]), 500)
					}}
					color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default EditDogsDialog
